import { render, staticRenderFns } from "./ImageTabs.vue?vue&type=template&id=4d5db7d2&scoped=true&"
import script from "./ImageTabs.vue?vue&type=script&lang=js&"
export * from "./ImageTabs.vue?vue&type=script&lang=js&"
import style0 from "./ImageTabs.vue?vue&type=style&index=0&id=4d5db7d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5db7d2",
  null
  
)

export default component.exports